<template>
    <div class="flex flex-wrap justify-center my-3">
        <div class="md:w-4/12 px-2 w-full">
            <label for="time-scale">Tiempo atrás</label>
            <custom-input
                id="time-value"
                v-model="timeValue"
                type="number"
                name="time-value"
                max="60"
                min="1"
                placeholder="1"
                autocomplete="off"
                @input="changeInput"
            />
        </div>
        <div class="md:w-4/12 px-2 w-full">
            <label for="time-scale">Escala</label>
            <custom-simple-select
                v-model="timeScale"
                placeholder="Escala"
                class="w-full"
                :options="timeScaleOptions"
                @change="changeInput"
            />
        </div>
    </div>
</template>

<script>
import CustomInput from "@/components/utils/CustomInput.vue";
import CustomSimpleSelect from "@/components/utils/CustomSimpleSelect.vue";

export default {
    name: "TimeAgoFilter",
    components: { CustomInput, CustomSimpleSelect },
    model: {
        prop: "itemsCurrent",
        event: "change"
    },
    props: {
        itemsCurrent: {
            type: Object,
            required: false,
            default: () => ({
                timeScale: "agoDays",
                timeValue: 1
            })
        }
    },
    data: () => ({
        timeScale: "agoDays",
        timeValue: 1,
        timeScaleOptions: [
            { label: "Días", value: "agoDays" },
            { label: "Meses", value: "agoMonths" }
        ]
    }),
    watch: {
        itemsCurrent(value) {
            this.setInput(value);
        }
    },
    mounted() {
        if (Object.keys(this.itemsCurrent).length === 0) {
            this.changeInput();
        } else {
            this.setInput(this.itemsCurrent);
        }
    },
    methods: {
        changeInput() {
            this.$emit("change", {
                timeScale: this.timeScale,
                timeValue: this.timeValue
            });
        },
        setInput(value) {
            this.timeScale = String(value.timeScale);
            this.timeValue = Number(value.timeValue);
        }
    }
};
</script>
